import axios from 'axios';
import { ErrorCode } from 'libs/commons/src/lib/error-constants';

export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;

      // Si no hay response (error de red) no hay nada que interceptar aquí
      if (!error.response) {
        return Promise.reject(error);
      }

      const errorCode = error.response.data?.code;

      if (error.response.status === 401 && !originalRequest._retry) {
        if (
          errorCode === ErrorCode.AUTH_TOKEN_EXPIRED ||
          errorCode === ErrorCode.AUTH_TOKEN_INVALID
        ) {
          const refreshToken = localStorage.getItem('rt');

          if (!refreshToken) {
            redirectToLogin();
            return Promise.reject(error);
          }

          originalRequest._retry = true;

          try {
            const res = await axios.post(
              '/refresh-token',
              { refresh_token: refreshToken },
              { headers: { 'Content-Type': 'application/json' } }
            );

            if (res.status === 201 && res.data) {
              localStorage.setItem('at', res.data);
              originalRequest.headers['Authorization'] = `Bearer ${res.data}`;
              return axios(originalRequest);
            }
          } catch (refreshError) {
            redirectToLogin();
            return Promise.reject(refreshError);
          }
        } else if (errorCode !== ErrorCode.AUTHENTICATION_FAILED) {
          // 401 que no es "token caducado/inválido" ni "credenciales incorrectas"
          // (p.ej. un endpoint protegido sin token) → redirige al login
          redirectToLogin();
        }
        // Si errorCode === AUTHENTICATION_FAILED (login fallido), no redirige:
        // deja que el catch de login.tsx lo muestre como mensaje en el propio formulario
      }

      return Promise.reject(error);
    }
  );
};

function redirectToLogin() {
  localStorage.removeItem('rt');
  localStorage.removeItem('at');
  window.location.href = '/login';
}
